import { useEffect } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useAnexosParteServico = () => {
  const {
    request: requestAnexoExcluir,
    data: dataAnexoExcluir,
    isLoading: isLoadingAnexoExcluir,
    errors: errorsAnexosExcluir,
  } = useApiClient();

  useEffect(() => {
    if (dataAnexoExcluir && !errorsAnexosExcluir) {
      toast.success("Anexo da Parte de Serviço removido com sucesso.");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }, [dataAnexoExcluir, errorsAnexosExcluir, isLoadingAnexoExcluir]);

  const excluirAnexo = (sqParteServico, sqParteServicoAnexo) => {
    requestAnexoExcluir(apiRoutes.fiscalizacao.parteservico.excluirAnexoParteServico, {
      sqParteServico,
      sqParteServicoAnexo,
    });
  };

  return { excluirAnexo };
};

export default useAnexosParteServico;
